export default "__VITE_ASSET__9aab96ae__"